export const OWNER_DETAILS_REQUEST = 'OWNER_DETAILS_REQUEST'
export const OWNER_DETAILS_SUCCESS = 'OWNER_DETAILS_SUCCESS'
export const OWNER_DETAILS_FAIL = 'OWNER_DETAILS_FAIL'
export const OWNER_DETAILS_RESET = 'OWNER_DETAILS_RESET'

export const OWNER_UPDATE_PROFILE_REQUEST = 'OWNER_UPDATE_PROFILE_REQUEST'
export const OWNER_UPDATE_PROFILE_SUCCESS = 'OWNER_UPDATE_PROFILE_SUCCESS'
export const OWNER_UPDATE_PROFILE_FAIL = 'OWNER_UPDATE_PROFILE_FAIL'
export const OWNER_UPDATE_PROFILE_RESET = 'OWNER_UPDATE_PROFILE_RESET'
